import React, {PureComponent} from 'react';

import PropTypes from 'prop-types';
import classNames from 'classnames';

import './button.css';

export default class Button extends PureComponent {
    constructor() {
        super();
        this.onClick=this.onClick.bind(this);
        this.onMouseDown=this.onMouseDown.bind(this);
        this.onMouseUp=this.onMouseUp.bind(this);
        
        this.state = {timer : null}
    }

    onMouseDown(evt) {
        if (!this.props.onLongPress) return
        clearTimeout(this.state.timer);
        this.setState({timer : setTimeout( t => {
                this.props.onLongPress();
            } , 500)
        });
    }

    onMouseUp(evt) {
        if (!this.props.onLongPress) return
        clearTimeout(this.state.timer);
    }
    
    onClick(evt) {
        if (!this.props.onClick) return;
        if(!this.props.disabled) this.props.onClick(evt);
    }

    render() {
        let { onClick, onMouseDown, onMouseUp, children, onLongPress, styling, className,curved, icon, ...others } = this.props;
        let buttonClasses = classNames({
            "cl-button":true,
            [`cl-button-${styling}`]:true,
            [className]:!!className,
            "disabled":this.props.disabled,
            "large":this.props.large
        })
        return(
             <button onClick={this.onClick} onMouseDown={this.onMouseDown} onMouseUp={this.onMouseUp} className={buttonClasses} {...others} >
                 {icon || null}
                 {this.props.children}
            </button>
        )
    }
}

Button.defaultProps={
    styling:"blank"
}

Button.propTypes = {
    large:PropTypes.bool
}


// WEBPACK FOOTER //
// ./src/components/Button/index.js